import { render, staticRenderFns } from "./tHome.vue?vue&type=template&id=e6e346f8&scoped=true"
import script from "./tHome.vue?vue&type=script&lang=js"
export * from "./tHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6e346f8",
  null
  
)

export default component.exports